import React from 'react';

const PageTransition = ({ children }) => {
  return <>{children}</>;
};

export default PageTransition;
